var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLilFlightIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 33,
    viewBox: "0 0 58 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0486 1.9698C33.5389 -1.87969 30.0272 1.92813 30.0272 1.92813L22.1709 7.93358L10.1726 2.87765L7.13337 5.21366L15.3785 13.9921L8.14551 19.8494L2.31561 17.2008L0.154297 19.1095L7.13337 25.7822C7.13337 25.7822 30.754 7.67935 31.6312 6.70527C32.5082 5.73185 36.6404 2.87786 36.0486 1.9698Z",
    fill: "#2E3192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4121 18.4795L29.0496 24.828L29.5879 21.3642L27.0599 13.3818L21.4121 18.4795Z",
    fill: "#2E3192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9366 7.87123C38.5026 7.58719 37.899 7.58719 37.4658 7.87123L32.1071 13.1607C31.6729 13.4433 31.4081 13.9671 31.4081 14.5341C31.4081 15.101 31.6761 15.6246 32.11 15.9076L37.4733 21.1967C37.9065 21.4807 38.5025 21.4807 38.9365 21.1967C39.37 20.9135 39.6984 20.391 39.6984 19.8229V16.9843L57.3853 14.4811L39.6984 11.9783V9.24484C39.6984 8.67677 39.3701 8.15422 38.9366 7.87123ZM56.5629 24.2088L51.1999 18.9187C50.7662 18.6357 50.1383 18.6357 49.7042 18.9187C49.271 19.2015 48.9094 19.7253 48.9094 20.2921V23.1311L31.2227 25.634L48.9094 28.137V30.8716C48.9094 31.4386 49.2708 31.9622 49.7042 32.2452C50.1383 32.5292 50.7717 32.5292 51.2053 32.2452L56.5655 26.9559C56.9995 26.6729 57.2651 26.1484 57.2651 25.5823C57.2651 25.0152 56.9967 24.4917 56.5629 24.2088Z",
    fill: "#2E3192"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLilFlightIcon2);
export default __webpack_public_path__ + "static/media/lil-flight-icon2.9e5a90123fa596186118fe7082c20cde.svg";
export { ForwardRef as ReactComponent };